// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"24":"9f896c0f","394":"7ea4312f","480":"ad253aa9","594":"10b18a78","838":"944c51ba"}[chunkId] + ".js";
};